import React from 'react';

const BrushIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      d="M14.4,2C16,.71,18.22-.79,19.51.49S19.29,4,18.05,5.6a62.16,62.16,0,0,1-4.77,5.16h0l0,0a31.44,31.44,0,0,1-5.57,4.49,3.43,3.43,0,0,1,.05.56,3.55,3.55,0,0,1-1,2.52C5.07,20,.89,20,.71,20a.73.73,0,0,1-.66-.44.73.73,0,0,1,.16-.78c.51-.51.47-1.16.36-2.18a4,4,0,0,1,.79-3.47,3.28,3.28,0,0,1,2.43-1,3.89,3.89,0,0,1,1,.12A31.17,31.17,0,0,1,9.21,6.75,63,63,0,0,1,14.4,2ZM2,18.51C3.35,18.38,5,18,5.68,17.35a2.13,2.13,0,0,0,.62-1.51,2.17,2.17,0,0,0-.62-1.52,2.76,2.76,0,0,0-1.89-.74,1.91,1.91,0,0,0-1.4.53c-.55.59-.51,1.27-.4,2.34A5.73,5.73,0,0,1,2,18.51ZM12.24,9.78a30.73,30.73,0,0,1-5.07,4.15,4.11,4.11,0,0,0-.48-.62,4.31,4.31,0,0,0-.62-.49,31.22,31.22,0,0,1,4.15-5.06c1.14-1.14,2.62-2.62,4.08-3.87L16.11,5.7C14.86,7.16,13.38,8.64,12.24,9.78ZM15.41,3,17,4.59c1.57-2,1.66-2.91,1.48-3.09S17.43,1.41,15.41,3Z"
      style={{ fillRule: 'evenodd' }}
    />
  </svg>
);

export default BrushIcon;
